import React from 'react';

// Overlay de progresso para operações de alguns segundos — salvar diagnóstico
// e concluir certificação geram o PDF no servidor (Puppeteer) e demoram.
//
// Barra INDETERMINADA de propósito: o servidor faz tudo numa tacada (grava +
// gera PDF + arquiva no SharePoint) e não reporta progresso parcial. Uma barra
// animada comunica "trabalhando" honestamente, sem fingir uma porcentagem que
// não temos. Cobre a tela e bloqueia novo clique enquanto processa.
const OverlayProgresso = ({ titulo = 'Processando…', subtitulo }) => (
  <div style={{
    position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(15,23,42,.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
  }}>
    <style>{'@keyframes barraProg{0%{left:-40%}100%{left:100%}}'}</style>
    <div style={{
      background: '#fff', borderRadius: 12, padding: '22px 24px', width: 'min(420px, 92vw)',
      boxShadow: '0 10px 40px rgba(0,0,0,.25)', textAlign: 'center',
    }}>
      <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 16 }}>{titulo}</div>
      {subtitulo && <div style={{ marginTop: 6, fontSize: 13, color: '#64748b' }}>{subtitulo}</div>}
      <div style={{
        marginTop: 16, position: 'relative', height: 8, background: '#e2e8f0',
        borderRadius: 999, overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: 0, height: '100%', width: '40%', borderRadius: 999,
          background: '#4f46e5', animation: 'barraProg 1.1s ease-in-out infinite',
        }} />
      </div>
    </div>
  </div>
);

export default OverlayProgresso;
